import { LegCrossService } from './leg-cross.service';
import { isFeatureEnabled } from '@approot/utilities';
import { LegHelperService } from './leg-helper.service';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Leg } from '@approot/models';
import { ProductsConfigService } from '@approot/services';
import { optionsChangeHandler } from '../utilities/leg.utilities';

@Injectable({
  providedIn: 'root'
})
export class LegCrossFormListenersService {
  constructor(
    private legHelperService: LegHelperService,
    private productsConfigService: ProductsConfigService,
    private legCrossService: LegCrossService
  ) {}

  public crossListeners(): void {
    const form = this.legHelperService.form;
    const leg = this.legHelperService.leg;
    this.crossListener(form);
    this.secondCrossListener(form);
  }

  private crossListener(form: FormGroup): void {
    this.legHelperService.subSink.sink = form
      .get('cross')
      ?.valueChanges.subscribe(val => {
        this.legCrossService.onCrossChange(
          val,
          this.legHelperService.legSyncingInfo,
          this.legHelperService.legIndex,
          this.legHelperService.fieldsToBeEdited
        );
      });
  }

  private secondCrossListener(form: FormGroup): void {
    this.legHelperService.subSink.sink = form
      .get('secondCross')
      ?.valueChanges.subscribe(val => {
        this.legCrossService.onSecondCrossChange(val);
      });
  }
}
